import type { MenuBoardConfig, ScoringWeights } from "./types.js";

export const DEFAULT_CONFIG: MenuBoardConfig = {
  maxItemsPerScreen: 6,
  scoringWeights: {
    combo: 50,
    popularity: 30,
    margin: 20,
  },
};

function normalizeWeights(weights: ScoringWeights): ScoringWeights {
  const total = weights.combo + weights.popularity + weights.margin;
  if (total === 0) return { ...DEFAULT_CONFIG.scoringWeights };
  if (total === 100) return { ...weights };
  const factor = 100 / total;
  return {
    combo: weights.combo * factor,
    popularity: weights.popularity * factor,
    margin: weights.margin * factor,
  };
}

function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}

export function resolveConfig(partial?: Partial<MenuBoardConfig>): MenuBoardConfig {
  if (!partial) return { ...DEFAULT_CONFIG };

  const maxItemsPerScreen = clamp(
    partial.maxItemsPerScreen ?? DEFAULT_CONFIG.maxItemsPerScreen,
    6,
    8,
  );

  const scoringWeights = normalizeWeights(
    partial.scoringWeights
      ? { ...DEFAULT_CONFIG.scoringWeights, ...partial.scoringWeights }
      : DEFAULT_CONFIG.scoringWeights,
  );

  return {
    maxItemsPerScreen,
    scoringWeights,
    preferredLayout: partial.preferredLayout,
    maxScreens: partial.maxScreens,
  };
}
